// in:cancelled,confirmed,attended,not_attended
import axiosClient from "./axiosClient";
import { API_ENDPOINTS, API_CREDENTIALS } from "./apiEndpoints";
import Cookies from "js-cookie";
const token = Cookies.get("token");
const customerId = Cookies.get("customerId");

export const changeTourStatus = ({ status, tourId }) => {
  return axiosClient.post(
    API_ENDPOINTS.CHANGE_TOUR_STATUS({ customerId, tourId }),
    {
      status: status,
    },
    {
      headers: {
        "secure-business-key": API_CREDENTIALS.SECURE_BUSINESS_KEY,
        Accept: "application/json",
        "user-token": token,
        "Accept-Language": "en",
      },
    }
  );
};
